import React, { FC } from 'react'

type MapContainerProps = {
  position: [number, number]
}

const MapContainer: FC<MapContainerProps> = ({ position }) => {
  return (
        <iframe 
          style={{width: '100%', height: '100%'}}

          id="gmap_canvas" 
          src="https://maps.google.com/maps?q=St.+Veiter+Stra%C3%9Fe+101,+9020+Klagenfurt,+Austria&t=&z=15&ie=UTF8&iwloc=&output=embed" 
          frameBorder="0" 
          scrolling="no" 
        >
        </iframe>
  )
}

export default MapContainer


